import { Component } from 'react';
import styles from './index.module.less';

/**
 * @param checked
 * @param disabled
 * @param className
 * @param type 默认灰色背景，white白色背景边框，black黑色背景框
 * @param onChange
 */
class InstaCheckBox extends Component {
  constructor(props) {
    super();
    this.state = {
      checked: !!props.checked,
    };
  }

  componentDidUpdate() {
    if (this.props.checked !== this.state.checked) {
      this.setState({ checked: this.props.checked });
    }
  }

  toggleChecked = (e) => {
    if (this.props.disabled) return;
    if (e?.target.tagName === 'A' && e?.target?.target === '_blank') return;
    this.setState({
      checked: !this.state.checked,
    });
    if (this.props.onChange) this.props.onChange(!this.state.checked);
  };

  render() {
    const { checked } = this.state;
    const { disabled } = this.props;

    return (
      <div
        className={[styles.CheckBox, this.props.className ?? ''].join(' ')}
        data-type={this.props.type}
        data-checked={`${checked}`}
        data-disabled={`${disabled}`}
      >
        <span
          className={styles.btn}
          style={{
            backgroundImage: `url(${
              checked
                ? this.props.type === 'black'
                  ? 'https://res.insta360.com/static/70acbe179b34befeab237a7aeb022cb4/Group%203.png'
                  : `https://res.insta360.com/static/a1adbc8b3f8f28c8f21526fe198096a3/active.png`
                : this.props.type
                ? ''
                : `https://res.insta360.com/static/89bc7c2dbed18a691ccb6b7cdddd49fc/default.png`
            })`,
          }}
          onClick={this.toggleChecked}
          dangerouslySetInnerHTML={{ __html: this.props.children }}
        />
      </div>
    );
  }
}

export default InstaCheckBox;
